<template>
    <div v-if="isLoading" class="cell-container loading">
      <ul :class="containerClassName">
        <li v-for="index in 10" :key="index">
          <div class="cell-img">
            <img :src="loadingImage" :width="imageSize"/>
          </div>
          <div class="cell-info">
            <div class="cell-title-wrap">
              <div class="cell-title title1 line1">&nbsp;</div>
              <div v-if="hasSecondSkeletonText" class="cell-title title3 line1">&nbsp;</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>
<script>

import { getBandTypeInfoByCellType } from '@/common/image.util'

export default {
  name: 'LoadingBand',
  data () {
    return {
      thumbnailInfo: {}
    }
  },
  props: ['isLoading', 'cellType', 'containerClassName'],
  computed: {
    loadingImage: function () {
      return `/img/common/img_default_thum_${this.thumbnailInfo.typeNumber}.png`
    },
    imageSize: function () {
      return this.thumbnailInfo.width
    },
    // getClass: function () {
    //   return `cell-list scroll cell-${this.thumbnailInfo.type}`
    // },
    hasSecondSkeletonText: function () {
      return this.thumbnailInfo.typeNumber === 2
    }
  },
  created () {
    this.thumbnailInfo = getBandTypeInfoByCellType(this.cellType)
  }
}
</script>
<style scoped>
  .cell-img img {
    opacity: 1;
  }
  .cell-title-wrap div{
    opacity: 1;
  }
</style>
